import { FC, useState } from "react";
import { Navbar, Nav, NavDropdown, Container, NavLink } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { changeLanguage, currentLanguage } from "../../i18n/type";
import { TFunction } from "i18next";
import NavDropdownComponent from "../components/NavDropdownComponent";
import { LANGUAGE_CODES, ROUTES } from "../../routes";

interface AppNavbarProps {
  maxWidth: number;
  screenWidth: number;
  t: TFunction<"translation", undefined>;
  headerHeight: number;
}

const AppNavbar: FC<AppNavbarProps> = (props: AppNavbarProps) => {
  const { t, maxWidth, headerHeight, screenWidth } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState<boolean>(false);
  const isActive = (path: string) =>
    location.pathname.endsWith(path) || path.endsWith(location.pathname);
  const toggleNavbar = () => setExpanded(!expanded);
  return (
    <Navbar bg="fourth" expand="md" expanded={expanded}>
      <Container>
        <div className="d-md-none">
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt={t("general.securitasBrandLogo")}
            title={t("general.securitasBrandLogo")}
            width={120}
          />
        </div>
        <Navbar.Toggle aria-controls="navbar-nav" onClick={toggleNavbar} />
        <Navbar.Collapse id="navbar-nav">
          <Nav
            className={
              screenWidth < 760 ? "mx-auto gap-4 text-center" : "mx-auto gap-4"
            }
            style={{ maxWidth: maxWidth }}
          >
            <Nav.Link
              className={`nav-link ${
                isActive(currentLanguage + ROUTES.home[currentLanguage])
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onMouseEnter={(e) =>
                e.currentTarget.classList.add("text-primary")
              }
              onMouseLeave={(e) =>
                e.currentTarget.classList.remove("text-primary")
              }
              onClick={() => {
                if (screenWidth < 760) {
                  toggleNavbar();
                }
                navigate(currentLanguage + ROUTES.home[currentLanguage]);
              }}
            >
              {t("header.navbar.home")}
            </Nav.Link>
            <Nav.Link
              className={`nav-link ${
                isActive(currentLanguage + "/" + ROUTES.about[currentLanguage])
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onMouseEnter={(e) =>
                e.currentTarget.classList.add("text-primary")
              }
              onMouseLeave={(e) =>
                e.currentTarget.classList.remove("text-primary")
              }
              onClick={() => {
                if (screenWidth < 760) {
                  toggleNavbar();
                }
                navigate(currentLanguage + "/" + ROUTES.about[currentLanguage]);
              }}
            >
              {t("header.navbar.about.title")}
            </Nav.Link>

            <Nav.Link
              className={`nav-link ${
                isActive(currentLanguage + "/" + ROUTES.services[currentLanguage])
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onMouseEnter={(e) =>
                e.currentTarget.classList.add("text-primary")
              }
              onMouseLeave={(e) =>
                e.currentTarget.classList.remove("text-primary")
              }
              onClick={() => {
                if (screenWidth < 760) {
                  toggleNavbar();
                }
                navigate(currentLanguage + "/" + ROUTES.services[currentLanguage]);
              }}
            >
              {t("header.navbar.services")}
            </Nav.Link>

            <Nav.Link
              className={`nav-link ${
                isActive(currentLanguage + "/" + ROUTES.experience[currentLanguage])
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onMouseEnter={(e) =>
                e.currentTarget.classList.add("text-primary")
              }
              onMouseLeave={(e) =>
                e.currentTarget.classList.remove("text-primary")
              }
              onClick={() => {
                if (screenWidth < 760) {
                  toggleNavbar();
                }
                navigate(currentLanguage + "/" + ROUTES.experience[currentLanguage]);
              }}
            >
              {t("header.navbar.experience")}
            </Nav.Link>

         


            {/* <Nav.Link
              className={`nav-link ${
                isActive(currentLanguage + "/" + ROUTES.blog[currentLanguage])
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onClick={() =>
                navigate(currentLanguage + "/" + ROUTES.blog[currentLanguage])
              }
            >
              {t("header.navbar.blog")}
            </Nav.Link> */}
            <Nav.Link
              className={`nav-link ${
                isActive(
                  currentLanguage + "/" + ROUTES.contact[currentLanguage]
                )
                  ? "active text-primary fw-bold"
                  : ""
              }`}
              onMouseEnter={(e) =>
                e.currentTarget.classList.add("text-primary")
              }
              onMouseLeave={(e) =>
                e.currentTarget.classList.remove("text-primary")
              }
              onClick={() => {
                if (screenWidth < 760) {
                  toggleNavbar();
                }
                navigate(
                  currentLanguage + "/" + ROUTES.contact[currentLanguage]
                );
              }}
            >
              {t("header.navbar.contact")}
            </Nav.Link>
            <NavDropdown
              title={
                <>
                  <span className="mx-3">{t("header.navbar.language")}</span>
                  <img
                    src={
                      currentLanguage === LANGUAGE_CODES.TR
                        ? `${process.env.PUBLIC_URL}/svg/tr.svg`
                        : currentLanguage === LANGUAGE_CODES.PL
                        ? `${process.env.PUBLIC_URL}/svg/pl.png`
                        : `${process.env.PUBLIC_URL}/svg/gb.svg`
                    }
                    alt="flag"
                    width={20}
                    height={15}
                  />
                </>
              }
              id="language-dropdown"
            >
              <NavDropdown.Item
                className={
                  window.localStorage.getItem("language") === LANGUAGE_CODES.TR
                    ? "text-primary fw-bold"
                    : ""
                }
                onClick={() => {
                  if (screenWidth < 760) {
                    toggleNavbar();
                  }
                  changeLanguage(LANGUAGE_CODES.TR);
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/tr.svg`}
                  alt="flag"
                  width={20}
                  height={15}
                />
                <span className="mx-3">{t("header.navbar.turkish")}</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                className={
                  window.localStorage.getItem("language") === LANGUAGE_CODES.EN
                    ? "text-primary fw-bold"
                    : ""
                }
                onClick={() => {
                  if (screenWidth < 760) {
                    toggleNavbar();
                  }
                  changeLanguage(LANGUAGE_CODES.EN);
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/gb.svg`}
                  alt="flag"
                  width={20}
                  height={15}
                />
                <span className="mx-3">{t("header.navbar.english")}</span>
              </NavDropdown.Item>
              <NavDropdown.Item
                className={
                  window.localStorage.getItem("language") === LANGUAGE_CODES.PL
                    ? "text-primary fw-bold"
                    : ""
                }
                onClick={() => {
                  if (screenWidth < 760) {
                    toggleNavbar();
                  }
                  changeLanguage(LANGUAGE_CODES.PL);
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/svg/pl.png`}
                  alt="flag"
                  width={20}
                  height={15}
                />
                <span className="mx-3">{t("header.navbar.polish")}</span>
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
